import {
	type AddCategoriesForArticleFailureAction,
	ADD_CATEGORIES_FOR_ARTICLE_FAILURE,
} from '../../actions/add-categories-for-article-failure/index.tsx';
import {
	ADD_CATEGORIES_FOR_ARTICLE_SUCCESS,
	type AddCategoriesForArticleSuccessAction,
} from '../../actions/add-categories-for-article-success/index.tsx';
import {
	ADD_CATEGORIES_FOR_ARTICLE,
	type AddCategoriesForArticleAction,
} from '../../actions/add-categories-for-article/index.tsx';
import {
	HIDE_BULK_CATEGORY_ADDER,
	type HideBulkCategoryAdderAction,
} from '../../actions/hide-bulk-category-adder/index.tsx';
import {
	SHOW_BULK_CATEGORY_ADDER,
	type ShowBulkCategoryAdderAction,
} from '../../actions/show-bulk-category-adder/index.tsx';
import {
	type UpdateCategoriesForArticleFailureAction,
	UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE,
} from '../../actions/update-categories-for-article-failure/index.tsx';
import {
	UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS,
	type UpdateCategoriesForArticleSuccessAction,
} from '../../actions/update-categories-for-article-success/index.tsx';
import {
	type UpdateCategoriesForArticleAction,
	UPDATE_CATEGORIES_FOR_ARTICLE,
} from '../../actions/update-categories-for-article/index.tsx';
import {
	UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER,
	type UpdateCategoriesInBulkCategoryAdderAction,
} from '../../actions/update-categories-in-bulk-category-adder/index.tsx';
import type { ArticlesState } from './types.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defaultState: Record<string, any> = {};

type HandledAction =
	| AddCategoriesForArticleAction
	| AddCategoriesForArticleFailureAction
	| AddCategoriesForArticleSuccessAction
	| UpdateCategoriesForArticleAction
	| UpdateCategoriesForArticleFailureAction
	| UpdateCategoriesForArticleSuccessAction
	| ShowBulkCategoryAdderAction
	| HideBulkCategoryAdderAction
	| UpdateCategoriesInBulkCategoryAdderAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: ArticlesState = defaultState, action: HandledAction): ArticlesState => {
	switch (action.type) {
		case ADD_CATEGORIES_FOR_ARTICLE:
		case UPDATE_CATEGORIES_FOR_ARTICLE: {
			const { categoryIds, articleId } = action.payload;
			return {
				...state,
				[articleId]: {
					isShowingBulkCategoryAdder: !!(
						state[articleId] && state[articleId].isShowingBulkCategoryAdder
					),
					categoriesInBulkCategoryAdder: state[articleId]
						? state[articleId].categoriesInBulkCategoryAdder
						: [],
					categoryIds,
				},
			};
		}
		case UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
		case ADD_CATEGORIES_FOR_ARTICLE_SUCCESS: {
			const { articleId } = action.payload;

			const newState = {
				...state,
			};

			delete newState[articleId];

			return newState;
		}

		case UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
		case ADD_CATEGORIES_FOR_ARTICLE_FAILURE: {
			const { failedCategoryIds, errorMessage, articleId } = action.payload;
			return {
				...state,
				[articleId]: {
					...state[articleId],
					failedCategoryIds,
					error: errorMessage,
				},
			};
		}

		case SHOW_BULK_CATEGORY_ADDER: {
			const { articleId } = action.payload;
			return {
				...state,
				[articleId]: {
					...state[articleId],
					isShowingBulkCategoryAdder: true,
				},
			};
		}

		case HIDE_BULK_CATEGORY_ADDER: {
			const { articleId } = action.payload;
			return {
				...state,
				[articleId]: {
					...state[articleId],
					isShowingBulkCategoryAdder: false,
					categoriesInBulkCategoryAdder: [],
				},
			};
		}

		case UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER: {
			const { articleId, categoryIds } = action.payload;
			return {
				...state,
				[articleId]: {
					...state[articleId],
					categoriesInBulkCategoryAdder: categoryIds,
				},
			};
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
